var styleDataHash = "95dfb735";
const injectCss = () => {
  var css = `.Yih9u{--wds-form-field-label-gap-small:9px}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var settings_component_default = {
  "formField": "Yih9u"
};
export {
  settings_component_default as default,
  injectCss
};
//# sourceMappingURL=settings-component-scss.js.map
